var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNopatients = function SvgIconNopatients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_379",
    "data-name": "Grupo 379",
    width: 49.135,
    height: 59.45,
    viewBox: "0 0 49.135 59.45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_378",
    "data-name": "Grupo 378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2224",
    "data-name": "Caminho 2224",
    d: "M29.6,32.359H19.526A19.593,19.593,0,0,0,0,51.975v6.07a1.4,1.4,0,0,0,2.809,0v-6.07a16.782,16.782,0,0,1,16.726-16.8H29.6a16.782,16.782,0,0,1,16.726,16.8v6.07a1.4,1.4,0,1,0,2.809,0v-6.07A19.615,19.615,0,0,0,29.6,32.359Zm-5.037-5.268a13.515,13.515,0,1,0-9.532-3.963A13.381,13.381,0,0,0,24.563,27.091ZM17.007,5.96a10.578,10.578,0,0,1,7.555-3.141h.251A10.693,10.693,0,1,1,17.007,5.96Z",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNopatients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-nopatients.21d47eca.svg";
export { ForwardRef as ReactComponent };